import { useState } from 'react'
import type { FC } from 'react'
import InputAdornment from '@mui/material/InputAdornment'
import IconButton from '@mui/material/IconButton'
import OpenPasswordIcon from '@/core/assets/OpenPassword.svg?react'
import ClosePasswordIcon from '@/core/assets/ClosePassword.svg?react'
import { UInput } from '../../UInput.component'
import { getFieldTestId } from '../field-helpers'
import type { FieldRenderer, FormFieldConfig, FieldRenderContext, Translate } from '../types'

const CvvField: FC<{ field: FormFieldConfig; ctx: FieldRenderContext; t: Translate }> = ({ field, ctx, t }) => {
    const key = field.key
    const [showCvv, setShowCvv] = useState(false)

    return (
        <UInput
            key={key}
            label={t(field.label)}
            type={showCvv ? 'text' : 'password'}
            value={(ctx.form[key] as string) ?? ''}
            onChange={e => {
                const next = e.target.value.replace(/\D/g, '')
                ctx.setForm((prev: Record<string, unknown>) => ({ ...prev, [key]: next }))
            }}
            fullWidth
            disabled={ctx.formDisabled}
            slotProps={{
                htmlInput: {
                    inputMode: 'numeric',
                    maxLength: 4,
                    'data-testid': getFieldTestId(ctx, key, 'input')
                },
                input: {
                    endAdornment: (
                        <InputAdornment position="end" data-testid={getFieldTestId(ctx, key, 'adornment')}>
                            <IconButton onClick={() => setShowCvv(v => !v)} edge="end" size="small" data-testid={getFieldTestId(ctx, key, 'toggle-button')}>
                                {showCvv ? (
                                    <OpenPasswordIcon width={22} height={14} data-testid={getFieldTestId(ctx, key, 'open-icon')} />
                                ) : (
                                    <ClosePasswordIcon width={22} height={12} data-testid={getFieldTestId(ctx, key, 'close-icon')} />
                                )}
                            </IconButton>
                        </InputAdornment>
                    )
                }
            }}
            data-testid={getFieldTestId(ctx, key, 'uinput')}
        />
    )
}

const renderCvvField: FieldRenderer = props => <CvvField {...props} />

export default renderCvvField
